import { connect } from "react-redux";
import ScalesCode from "../js/admin/ScalesCode";
import { withRouter } from "react-router-dom";
import EntityPage from "../components/EntityPage";


class Scales extends EntityPage {

    constructor() {
        super('admin_local.menus.Scales');
        this.code = new ScalesCode()
    }

}
const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus && props.rootReducer.myStatus.restaurant_id) {
        return {
            restaurant: props.rootReducer.restaurant,
            myStatus: props.rootReducer.myStatus,
            admin_local: props.rootReducer.admin_local,
            local: props.rootReducer.local,
            speechRecognitionOn: props.rootReducer.speechRecognitionOn,
            ai: props.rootReducer.ai,
            speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable,
        };
    }
    return {};
};

export default connect(mapStateToProps)(withRouter(Scales));
